/**
 * Central Highcharts configuration.
 * Initializes Highcharts with required modules and configures @highcharts/react.
 */
import { setHighcharts } from '@highcharts/react/Stock';
// Import Highstock - must come first
import Highcharts from 'highcharts/highstock';

// imports - these auto-register with Highcharts
import 'highcharts/highcharts-more';
import 'highcharts/modules/sankey';
import 'highcharts/modules/exporting';
import 'highcharts/modules/full-screen';
import 'highcharts/modules/stock-tools';
import 'highcharts/modules/annotations-advanced';
import 'highcharts/modules/price-indicator';
import 'highcharts/indicators/indicators-all';
import 'highcharts/indicators/apo';
import 'highcharts/indicators/aroon';
import 'highcharts/indicators/aroon-oscillator';
import 'highcharts/indicators/bollinger-bands';
import 'highcharts/indicators/cmo';
import 'highcharts/indicators/dema';
import 'highcharts/indicators/disparity-index';
import 'highcharts/indicators/dpo';
import 'highcharts/indicators/indicators';
import 'highcharts/indicators/macd';
import 'highcharts/indicators/ppo';
import 'highcharts/indicators/psar';
import 'highcharts/indicators/regressions';
import 'highcharts/indicators/roc';
import 'highcharts/indicators/rsi';
import 'highcharts/indicators/tema';
import 'highcharts/indicators/trendline';
import 'highcharts/indicators/trix';

// Configure @highcharts/react to use this instance
setHighcharts(Highcharts as any);

export { Highcharts, setHighcharts };
